import CSVDownloadProgressStore from 'states/csvDownloadProgress'

function useCSVDownloadProgress() {
  const store = CSVDownloadProgressStore.useState(s => s)

  return {
    pollStatus: store.status,
    updatePollStatus: newStatus => {
      const validStatuses = ['poll', 'idle', 'once']
      const isValidStatus = validStatuses.includes(newStatus)

      if (isValidStatus) {
        CSVDownloadProgressStore.update(s => {
          // eslint-disable-next-line no-param-reassign
          s.status = newStatus
        })
      }
    }
  }
}

export default useCSVDownloadProgress
